import { render, staticRenderFns } from "./speech_template_details.vue?vue&type=template&id=5e084fde&"
import script from "./speech_template_details.vue?vue&type=script&lang=js&"
export * from "./speech_template_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports